import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'type',
      type: 'select',
      label: '选择类型',
      placeholder: '请选择类型',
      options: [
        { title: '文案', value: '1' },
        { title: '图片', value: '2' }
      ],
      rules: { required: true, message: '类型是必选的', trigger: 'blur' }
    },
    {
      field: 'title',
      type: 'input',
      label: '标题',
      filterable: true,
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必填的', trigger: 'blur' }
    },
    {
      field: 'sort',
      type: 'number',
      label: '列表排序',
      styles:{width:'200px'},
      rules: { required: true, message: '请输入排序值 0-100 之间', trigger: 'blur' }
    },
    // {
    //   field: 'QandAs',
    //   type: 'customSlot',
    //   label: '',
    //   labelWidth:'1px',
    //   filterable: true,
    // },
    // {
    //   field: 'images',
    //   type: 'customSlot',
    //   label: '',
    //   labelWidth:'1px',
    //   filterable: true,
    // },
  ],
  colLayout: 24,
  itemStyle: {}
}
